import { styled } from '@mui/material'

const ErrorText = styled('span')(({ theme }) => ({
  color: theme.palette.error.main,
}))

export default ErrorText
